import { useScheduleDashboardContext } from '../context/ScheduleDashboardContext';

import useSchedulesDashboardColumns from './useSchedulesDashboardColumns';

export const useSchedulesDashboard = () => {
  const {
    showEventTypeDrawer,
    mainLoading,
    groupBy,
    openTimelineEvents,
    intl,
    setShowEventTypeDrawer,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    fetch,
    queryDivisionIds,
    canQueryDivisions,
    permissionsLoaded,
    disabledDate,
    setSelectedSchedules,
    setScheduleSelectorLoading,
    toggle,
    isOpen,
  } = useScheduleDashboardContext();

  const columns = useSchedulesDashboardColumns();

  return {
    showEventTypeDrawer,
    mainLoading,
    groupBy,
    openTimelineEvents,
    intl,
    setShowEventTypeDrawer,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    fetch,
    queryDivisionIds,
    canQueryDivisions,
    permissionsLoaded,
    disabledDate,
    setSelectedSchedules,
    setScheduleSelectorLoading,
    toggle,
    isOpen,
    columns,
  };
};
